/**
 * @flow
 * @relayHash 831c35ad3eb11b143f493577259a7ea4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PaymentModeUpdateInput = {|
  id: string,
  name: string,
|};
export type UpdatePaymentModeMutationVariables = {|
  data: PaymentModeUpdateInput
|};
export type UpdatePaymentModeMutationResponse = {|
  +updatePaymentMode: {|
    +id: string
  |}
|};
export type UpdatePaymentModeMutation = {|
  variables: UpdatePaymentModeMutationVariables,
  response: UpdatePaymentModeMutationResponse,
|};
*/


/*
mutation UpdatePaymentModeMutation(
  $data: PaymentModeUpdateInput!
) {
  updatePaymentMode(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "PaymentModeUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updatePaymentMode",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "PaymentModeModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdatePaymentModeMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdatePaymentModeMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdatePaymentModeMutation",
    "id": null,
    "text": "mutation UpdatePaymentModeMutation(\n  $data: PaymentModeUpdateInput!\n) {\n  updatePaymentMode(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '387485cf3987463f3e82ed415e1d15bc';
module.exports = node;
